
define('jsx!components/modal/share',[
	"react",
	"actions/viewbuncee",
	"jsx!components/modal/share/share-email",
	"jsx!components/modal/share/share-settings",
	"jsx!components/modal/share/share-social-media",
	"jsx!components/modal/share/share-code",
	"jsx!components/modal/share/share-rsvp",
	"jsx!components/modal/share/share-direct-student",
	"jsx!components/modal/share/share-direct-teacher",
	"shared/user"
], function(React, ViewBunceeActions, ShareEmail, ShareSettings, ShareSocialMedia, ShareCode, ShareRSVP, ShareDirectStudent, ShareDirectTeacher, User) {
	return React.createClass({
		displayName: "ShareModal",
		getInitialState: function() {
			var selected = 4;

			if(!window.appData.user || !(window.appData.user.data.guid == window.appData.buncee.data.owner_guid)) {
				selected = 0;
			}

			return {
				selected: selected,
				error: 0,
				recepients: [],
				hasBeenEmailed: false,
				numSentEmails: 0,
				errorText: null
			};
		},
		componentDidMount: function() {
			var self = this;

			if(window.appData.user) {
				window.api.request("emailActivity", this.props.stores.buncee.getBuncee().guid, "hasBeenEmailed").execute().done(function(response) {
					self.setState({hasBeenEmailed: response.hasBeenEmailed});
				});

				// How many emails have been sent for this buncee?
				window.api.request("emailActivity", this.props.stores.buncee.getBuncee().guid, "getOne")
				.execute()
				.done(function(response) {
					try {
						self.setState({
							numSentEmails: parseInt(response.data[0].total) || 0,
						});
					} catch (error) {
						/*NO-OP*/
					}
				});
			}
		},
		showEmailTrackingButton: function() {
			this.setState({
				hasBeenEmailed: true,
			});
		},
		componentWillMount: function() {
			this.props.stores.buncee.addChangeListener(this.handleChangeFromBunceeStore);
			this.actions = new ViewBunceeActions();
		},
		componentWillUnmount: function() {
			this.props.stores.buncee.removeChangeListener(this.handleChangeFromBunceeStore);
		},
		handleChangeFromBunceeStore: function() {
			this.forceUpdate();
		},
		hasPermission: function(permission) {
			return User.hasPermission(permission);
		},
		done: function(e) {
			this.hide(e);
		},
		hide: function(e) {
			e.preventDefault();
			e.stopPropagation();
			var parent = document.getElementById('buncee-modal');
			React.unmountComponentAtNode(parent);
		},
		didClickOverlay: function(e) {
			this.hide(e);
		},
		tabLink: function() {
			this.setState({ selected: 0 });
		},
		tabEmail: function() {
			if(window.appData.user) {
				this.setState({ selected: 1 });
			} else {
				this.actions.toast(".buncee-modal-action", "Please login to access this feature");
			}
		},
		tabRSVP: function() {
			if(window.appData.user) {
				this.setState({ selected: 2 });
			} else {
				this.actions.toast(".buncee-modal-action", "Please login to access this feature");
			}
		},
		tabSocial: function() {
			this.setState({ selected: 3 });
		},
		tabSettings: function() {
			this.setState({ selected: 4 });
		},
		tabShareDirect: function () {
			this.setState({ selected: 5 });
		},
		addEmail: function(list) {
			var recepients = this.state.recepients;
			
			list = $.map(list, function(l) {
				l = l.trim();
				if(l.length > 3)
					return l;
			});

			recepients.push.apply(recepients, list);

			this.setState({ recepients: recepients });

			$('#newemail').val('');
			var $node = $(React.findDOMNode(this.refs.emailList));
			$node.animate({
				"scrollTop": $node.height()
			}, 500);
		},
		renderPrivacyLevelWarning: function(level) {
			return React.createElement("div", {className: "modal-tab-area alert alert-warning"}, 
				"Your privacy level is currently set to ", React.createElement("strong", null, level), ". Please change this to enable sharing."
			);
		},
		render: function() {
			var self = this;
			var tabContent;
			var tabClass = "modal-tab-title";
			var tabClassActive = "modal-tab-title-active";

			var webTab = React.createElement("span", {className: this.state.selected === 0 ? tabClassActive : tabClass, onClick: this.tabLink}, "Code")
			var emailTab = React.createElement("span", {className: this.state.selected === 1 ? tabClassActive : tabClass, onClick: this.tabEmail}, "Email")
			var settingsTab = React.createElement("span", {className: this.state.selected === 4 ? tabClassActive : tabClass, onClick: this.tabSettings}, "Settings");
			var socialTab;
			if(typeof Windows === 'undefined') {
				socialTab = React.createElement("span", {className: this.state.selected === 3 ? tabClassActive : tabClass, onClick: this.tabSocial, onTouchEnd: this.tabSocial}, "Social");
			}
			var rsvpTab = React.createElement("span", {className: this.state.selected === 2 ? tabClassActive : tabClass, onClick: this.tabRSVP}, "RSVP");
			var shareDirectTab;
			if(User.isTeacher()) {
				shareDirectTab = React.createElement("span", {style: {width:'150px'}, className: this.state.selected === 5 ? tabClassActive : tabClass, onClick: this.tabShareDirect, onTouchEnd: this.tabShareDirect}, "Share With Students");
			} else if(User.isStudent()) {
				shareDirectTab = React.createElement("span", {style: {width:'150px'}, className: this.state.selected === 5 ? tabClassActive : tabClass, onClick: this.tabShareDirect, onTouchEnd: this.tabShareDirect}, "Share With Teachers");
			}

			/*
			 * Hide the settings tab and share tab if you don't own the buncee.
			 */
			if(!window.appData.user || !(window.appData.buncee.data.owner_guid === window.appData.user.data.guid)) {
				settingsTab = null;
				shareDirectTab = null;
			}

			if (!this.hasPermission('share.rsvp')) {
				rsvpTab = null;
			}

			if (!this.hasPermission('share.email')) {
				emailTab = null;
			}
			
			if (!this.hasPermission('share.facebook') && 
				!this.hasPermission('share.twitter') &&
				!this.hasPermission('share.gplus') &&
				!this.hasPermission('share.pinterest') &&
				!this.hasPermission('share.linkedin') &&
				!this.hasPermission('share.google-classroom'))
			{
				socialTab = null;
			}

			var displayCloseButton = true;
			switch(this.state.selected) {
				// Share by Codes or Links
				default:
				case 0:
					tabContent = React.createElement(ShareCode, {
						actions: this.actions, 
						renderPrivacyLevelWarning: this.renderPrivacyLevelWarning}
					);
					break;
				// Share by Email
				case 1:
					tabContent = React.createElement(ShareEmail, {
						numSentEmails: this.state.numSentEmails, 
						hasBeenEmailed: this.state.hasBeenEmailed, 
						renderPrivacyLevelWarning: this.renderPrivacyLevelWarning, 
						showEmailTrackingButton: this.showEmailTrackingButton}
					);
					break;
				// Share by RSVP
				case 2:
					tabContent = React.createElement(ShareRSVP, {
						numSentEmails: this.state.numSentEmails, 
						hasBeenEmailed: this.state.hasBeenEmailed, 
						renderPrivacyLevelWarning: this.renderPrivacyLevelWarning, 
						setHasBeenEmailed: function (value) {
							self.setState({
								hasBeenEmailed: value == true
							});
						}}
					);
					break;
				// Share by Social Media
				case 3:
					tabContent = React.createElement(ShareSocialMedia, {
						renderPrivacyLevelWarning: this.renderPrivacyLevelWarning}
					);
					break;
				// Share Setting
				case 4:
					tabContent = React.createElement(ShareSettings, {
						actions: this.actions}
					);
					break;
				case 5:
					displayCloseButton = false;
					if(window.appData.user.data.type === "student") {
						tabContent = React.createElement(ShareDirectStudent, {
							stores: this.props.stores, 
							actions: this.actions, 
							toggleCopyable: this.props.toggleCopyable, 
							toggleCommentable: this.props.toggleComment, 
							hideModal: this.hide}
						);
					} else {
						tabContent = React.createElement(ShareDirectTeacher, {
							stores: this.props.stores, 
							actions: this.actions, 
							toggleCopyable: this.props.toggleCopyable, 
							toggleCommentable: this.props.toggleComment, 
							hideModal: this.hide}
						);
					}
					break;
			}

			return (
				React.createElement("div", null, 
					React.createElement("div", {className: "buncee-modal", style: { width: "700px"}}, 
						React.createElement("div", {className: "buncee-modal-title"}, "Share"), 
						React.createElement("div", {className: "buncee-modal-action"}, 
							React.createElement("div", null, 
								settingsTab, 
								webTab, 
								emailTab, 
								shareDirectTab, 
								rsvpTab, 
								socialTab
							), 
							tabContent
						), 
						displayCloseButton ? React.createElement("div", {className: "buncee-modal-buttons"}, 
							React.createElement("div", {className: "modal-button button-red", onClick: this.hide, onTouchEnd: this.hide}, "CLOSE")
						) : null
					), 
					React.createElement("div", {id: "overlay", onClick: this.didClickOverlay})
				)
			);
		}
	});
});
